/**
 * @fileoverview ค่ากลางสำหรับโหลด Google Maps JavaScript API
 * ทุกจุดที่โหลดแผนที่ต้องใช้คีย์/id/libraries ชุดเดียวกัน ไม่งั้น script จะโหลดชนกัน
 * (Google ตอบ "This page didn't load Google Maps correctly")
 * @module utils/googleMaps
 */

// คีย์จริงตั้งไว้ที่ REACT_APP_API_MAP_KEY - REACT_APP_GOOGLE_MAPS_API_KEY ใช้เป็น fallback เท่านั้น
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_API_MAP_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const GOOGLE_MAPS_LOADER_ID = 'google-map-script';

// ต้องเป็น array ตัวเดียวกัน (reference เดียว) ในทุก loader
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'drawing'];
